
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"-19614.098 3370 23.664 12"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"group-195","transform":"translate(-19614.098 3370)","opacity":".54"}},[_c('rect',{staticClass:"cls-2",attrs:{"id":"rectangle-26","width":"2.726","height":"12","rx":"1.363"}}),_c('rect',{staticClass:"cls-3",attrs:{"id":"rectangle-26-2","width":"2.726","height":"12","data-name":"rectangle-26","rx":"1.363","transform":"translate(5.093)"}}),_c('rect',{attrs:{"id":"rectangle-26-3","width":"2.726","height":"12","data-name":"rectangle-26","rx":"1.363","transform":"translate(10.186)","opacity":".87","fill":"#444"}}),_c('rect',{staticClass:"cls-3",attrs:{"id":"rectangle-26-4","width":"2.726","height":"12","data-name":"rectangle-26","rx":"1.363","transform":"translate(15.844)"}}),_c('rect',{staticClass:"cls-2",attrs:{"id":"rectangle-26-5","width":"2.726","height":"12","data-name":"rectangle-26","rx":"1.363","transform":"translate(20.937)"}})])])
          )
        }
      }
    